// extracted by mini-css-extract-plugin
export default {"labelContainer":"_6eed815c","label":"_8510a7db"};